'use client';

import type { ReactElement } from 'react';
import { IconChevronDown } from '@tabler/icons-react';
import { ColorType } from '@/theme/colors';
import { Cicon } from '../Cicon';
import { Cprofileimage } from '../Cprofileimage';

interface NavbarProfileReadyActionProps {
  chevronSize: number;
  onProfileClick: () => void;
  profileImageSize: number;
  profileImageSrc?: string;
}

export function NavbarProfileReadyAction({
  chevronSize,
  onProfileClick,
  profileImageSize,
  profileImageSrc,
}: NavbarProfileReadyActionProps): ReactElement {
  return (
    <Cprofileimage
      dataElScope="Cpagelayout/NavbarProfileReadyAction"
      size={profileImageSize}
      borderWidth={1}
      borderOpacity={0.32}
      src={profileImageSrc}
      onClick={onProfileClick}
      tooltip={
        <Cicon
          icon={IconChevronDown}
          size={chevronSize}
          color={ColorType.White}
          opacity={0.5}
        />
      }
    />
  );
}
